module.exports = __webpack_public_path__ + "img/full3-min.863e87a0.png";